var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccounts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.342V8.753C0 7.834.731 7.1 1.644 7.1H3.69l.11-.883c-1.242-.514-2.12-1.801-1.973-3.272C1.973 1.364 3.288.076 4.859.003 6.722-.071 8.256 1.4 8.256 3.238c0 1.324-.804 2.5-1.972 2.978l.11.883h2.045c.913 0 1.644.735 1.644 1.654v5.59c0 .146-.11.293-.293.293H.293A.289.289 0 0 1 0 14.342zM9.717 3.863A2.49 2.49 0 0 0 11.215 6.4l-.11.699h-.986c.438.404.694.992.694 1.654v4.964h4.968c.11 0 .219-.11.219-.22V8.348c0-.736-.585-1.287-1.278-1.287H13.15l-.073-.699a2.444 2.444 0 0 0 1.534-2.28 2.467 2.467 0 0 0-2.594-2.463 2.473 2.473 0 0 0-2.301 2.243z",
    fill: "#0A68FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounts);
export default ForwardRef;